module.exports = __webpack_public_path__ + "img/canal.360c0538.jpg";